import React, { Component } from 'react'
import Button from 'src/components/common/Button'
import PropTypes from 'prop-types'
import { changeEventForm } from 'src/actions/event'
import { connect } from 'react-redux'
import RightIconWhite from 'src/assets/icons/right-icon-white.png'
import CloseIconGray from 'src/assets/icons/close-icon-gray.png'
import styles from './second-step.scss'
import FlyerContainerV2 from '../FlyerContainerV2/FlyerContainerV2'
import CustomFlyerPicker from 'src/components/common/CustomFlyerPicker'
import { clearCustomFlyerBg } from 'src/actions/flyer'
import FlyerContainerEmptyDesign from '../FlyerContainerEmptyDesign/FlyerContainerEmptyDesign'

class SecondStep extends Component {
  selectedFlyerRef

  handleButtonClick = () => {
    if (this.props.type === 'create') {
      this.selectedFlyerRef?.canvasToImage()
      window.mixpanel.track('SAVE DESIGN Clicked', { user_id: this.props.userId })
    }
    this.props.onButtonClick()
  }

  handleImageClick = (item, index) => {
    const { onChangeEventForm, eventForm } = this.props

    if (eventForm.checkedImage === item + index) {
      onChangeEventForm({ checkedImage: null })
    } else {
      onChangeEventForm({ checkedImage: item + index })
    }
  }

  componentDidMount() {
    if (this.props.onSecondStepRef) {
      this.props.onSecondStepRef(this)
    }
  }

  render() {
    const { eventForm, type, flyerList, customFlyerBg, onChangeEventForm } = this.props

    return (
      <div className={styles['second-step-container']}>
        <div onScroll={this.handleScroll} className={styles['image-view']}>
          <div className={styles['image-wrapper']}>
            <div className={styles['hide-mobile']}>
              <CustomFlyerPicker />
            </div>
            {customFlyerBg.bgDataURL && (
              <FlyerContainerEmptyDesign
                eventForm={eventForm}
                onChangeEventForm={onChangeEventForm}
                customBgDataURL={customFlyerBg.bgDataURL}
                onFlyerSelected={flyerRef => {
                  this.selectedFlyerRef = flyerRef
                }}
              />
            )}

            {flyerList.map((item, index) => {
              if (!item.image_bg_slug) {
                return null
              }
              return (
                <FlyerContainerV2
                  flyerDetail={item}
                  key={index}
                  customBgDataURL={customFlyerBg.bgDataURL}
                  onFlyerSelected={flyerRef => {
                    this.selectedFlyerRef = flyerRef
                  }}
                  eventForm={eventForm}
                  onChangeEventForm={onChangeEventForm}
                />
              )
            })}
          </div>
        </div>
        <div className={styles['button-wrapper']}>
          {customFlyerBg.bgDataURL && (
            <Button
              className={styles['remove-image-button']}
              purple
              onClick={() => {
                this.props.clearCustomFlyerBg()
              }}
            >
              <img src={CloseIconGray} alt="" width="16" />
              <span>Remove Image</span>
            </Button>
          )}
          <Button
            className={styles['button-inner']}
            onClick={this.handleButtonClick}
            disabled={!eventForm.flyer_design_number}
          >
            <span>{type === 'create' ? 'SAVE DESIGN' : 'change'}</span>
            <img src={RightIconWhite} alt="" width="24" />
          </Button>
        </div>
      </div>
    )
  }
}

SecondStep.defaultProps = {
  type: 'create'
}

SecondStep.propTypes = {
  userId: PropTypes.string,
  onButtonClick: PropTypes.func,
  onChangeEventForm: PropTypes.func,
  eventForm: PropTypes.object,
  type: PropTypes.string,
  flyerList: PropTypes.array,
  customFlyerBg: PropTypes.object,
  clearCustomFlyerBg: PropTypes.func,
  onSecondStepRef: PropTypes.func
}

function mapStateToProps(state) {
  return {
    eventForm: state.frontend.eventForm,
    flyerList: state.frontend.flyerList,
    customFlyerBg: state.frontend.customFlyerBg,
    userId: state.userId
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onChangeEventForm: params => dispatch(changeEventForm(params)),
    clearCustomFlyerBg: () => dispatch(clearCustomFlyerBg())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SecondStep)
